import $ from 'jquery';
import { commonMiddleware, protectRoute } from '../middleware';
import { initHomeExperience } from '~src/home';
import { initSidebarProfile } from '../../sidebar-profile';
import { trackPageView } from '~src/tracking';
import React from 'react';
import ReactDOM from 'react-dom';
import { AIsPage } from '~src/components/AI';

export const aiRoute = async () => {
  document.title = 'IA | Giotto';

  await protectRoute();
  await commonMiddleware();

  // Ensure the window is at the top before rendering
  try {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  } catch (e) {
    // no-op
  }

  // Hide app navbars for dashboard layout consistency
  $('#navbar-private').hide();
  $('#navbar-canvas').hide();
  $('.logo').hide();

  // Show AI route
  $('#route-ai').show();

  // Match Products behavior: let the document scroll; keep sidebar sticky
  $('body').removeClass('dashboard dashboard-sidebar-open');

  // Setup responsive sidebar interactions and profile menu
  initHomeExperience();
  initSidebarProfile();

  // Render AI catalog
  const domContainer = document.querySelector('#ai-root');
  ReactDOM.render(React.createElement(AIsPage), domContainer);

  // Pageview tracking
  trackPageView('IA');
};
